import React from 'react';

function EquatorialGuinea(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124115)">
        <mask
          id="mask0_800_124115"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124115)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124115"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124115)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V8H36V0H0Z"
              fill="#009D00"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 8V16H36V8H0Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16V24H36V16H0Z"
              fill="#F80000"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24L9 12.152L0 0Z"
            fill="#0075D5"
          />
          <mask
            id="mask2_800_124115"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="9"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24L9 12.152L0 0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_800_124115)" />
          <path
            d="M16.3892 8.88262L16.3773 8.88501L16.3683 8.87766L16.1311 8.68287L16.1018 8.96506L16.1004 8.97909L16.0872 8.98563L15.8121 9.1227L16.1042 9.23435L16.116 9.23885L16.1187 9.25093L16.1819 9.53305L16.3954 9.31683L16.4045 9.30757L16.4172 9.30891L16.733 9.34204L16.5718 9.10105L16.5641 9.08955L16.5708 9.07676L16.7042 8.81936L16.3892 8.88262Z"
            fill="#FFD500"
            stroke="black"
            strokeWidth="0.05"
          />
          <path
            d="M17.5142 8.88262L17.5023 8.88501L17.4933 8.87766L17.2561 8.68287L17.2268 8.96506L17.2254 8.97909L17.2122 8.98563L16.9371 9.1227L17.2292 9.23435L17.241 9.23885L17.2437 9.25093L17.3069 9.53305L17.5204 9.31683L17.5295 9.30757L17.5422 9.30891L17.858 9.34204L17.6968 9.10105L17.6891 9.08955L17.6958 9.07676L17.8292 8.81936L17.5142 8.88262Z"
            fill="#FFD500"
            stroke="black"
            strokeWidth="0.05"
          />
          <path
            d="M18.6392 8.88262L18.6273 8.88501L18.6183 8.87766L18.3811 8.68287L18.3518 8.96506L18.3504 8.97909L18.3372 8.98563L18.0621 9.1227L18.3542 9.23435L18.366 9.23885L18.3687 9.25093L18.4319 9.53305L18.6454 9.31683L18.6545 9.30757L18.6672 9.30891L18.983 9.34204L18.8218 9.10105L18.8141 9.08955L18.8208 9.07676L18.9542 8.81936L18.6392 8.88262Z"
            fill="#FFD500"
            stroke="black"
            strokeWidth="0.05"
          />
          <path
            d="M19.7642 8.88262L19.7523 8.88501L19.7433 8.87766L19.5061 8.68287L19.4768 8.96506L19.4754 8.97909L19.4622 8.98563L19.1871 9.1227L19.4792 9.23435L19.491 9.23885L19.4937 9.25093L19.5569 9.53305L19.7704 9.31683L19.7795 9.30757L19.7922 9.30891L20.108 9.34204L19.9468 9.10105L19.9391 9.08955L19.9458 9.07676L20.0792 8.81936L19.7642 8.88262Z"
            fill="#FFD500"
            stroke="black"
            strokeWidth="0.05"
          />
          <path
            d="M20.8892 8.88262L20.8773 8.88501L20.8683 8.87766L20.6311 8.68287L20.6018 8.96506L20.6004 8.97909L20.5872 8.98563L20.3121 9.1227L20.6042 9.23435L20.616 9.23885L20.6187 9.25093L20.6819 9.53305L20.8954 9.31683L20.9045 9.30757L20.9172 9.30891L21.233 9.34204L21.0718 9.10105L21.0641 9.08955L21.0708 9.07676L21.2042 8.81936L20.8892 8.88262Z"
            fill="#FFD500"
            stroke="black"
            strokeWidth="0.05"
          />
          <path
            d="M22.0142 8.88262L22.0023 8.88501L21.9933 8.87766L21.7561 8.68287L21.7268 8.96506L21.7254 8.97909L21.7122 8.98563L21.4371 9.1227L21.7292 9.23435L21.741 9.23885L21.7437 9.25093L21.8069 9.53305L22.0204 9.31683L22.0295 9.30757L22.0422 9.30891L22.358 9.34204L22.1968 9.10105L22.1891 9.08955L22.1958 9.07676L22.3292 8.81936L22.0142 8.88262Z"
            fill="#FFD500"
            stroke="black"
            strokeWidth="0.05"
          />
          <path
            d="M16.925 10.05H21.325V12.75C21.325 13.965 20.34 14.95 19.125 14.95C17.91 14.95 16.925 13.965 16.925 12.75V10.05Z"
            stroke="#373737"
            strokeWidth="0.1"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.8173 11.9598C18.8173 11.9598 18.5904 14.3251 18.3639 14.4684C18.1373 14.6118 19.4494 14.6834 19.5748 14.5759C19.7002 14.4684 19.0026 12.541 19.2426 11.9598C19.4825 11.3786 19.869 11.3315 19.869 11.3315C19.869 11.3315 19.3818 11.24 19.2426 11.4144C19.1033 11.5888 18.6881 11.3315 18.6881 11.3315L18.8173 11.9598Z"
            fill="#6F3E1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7676 11.8262H18.593C18.593 11.8262 18.4748 12.2369 18.2037 12.0315C17.9326 11.8262 17.55 11.8986 17.55 11.8986C17.55 11.8986 17.5844 11.6528 18.0006 11.5551C18.4169 11.4574 18.593 10.6639 18.593 10.6639C18.593 10.6639 19.1821 10.469 19.5405 10.8684C19.8989 11.2679 20.4037 11.0975 20.4037 11.0975C20.4037 11.0975 20.7727 11.284 20.5882 11.5551C20.4037 11.8262 20.089 12.0245 19.8147 11.8262C19.5405 11.6279 18.7676 11.8262 18.7676 11.8262Z"
            fill="#009D29"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124115">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default EquatorialGuinea;
